import React, { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { FullScreenLoader } from 'components/FullScreenLoader';
import { GoogleTagManagerService } from 'gtm';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';
import { SubscriptionService } from 'services/subscription-service';
import { POST_BILLING_PORTAL_SUMMARY_QUERY_KEY } from 'shared/constants/query-keys';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { extractRedirectPathFromQueryParams } from 'shared/utils/navigation';

export function PostBillingSessionHandlerPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = queryString.parse(location.search);
  const { sessionCreatedAt } = queryParams;
  const redirectPath = extractRedirectPathFromQueryParams(queryParams);

  const getPostBillingSessionSummary = useQuery({
    queryKey: [POST_BILLING_PORTAL_SUMMARY_QUERY_KEY, sessionCreatedAt],
    queryFn: () => SubscriptionService.getPostBillingSessionSummary(Number(sessionCreatedAt)),
    enabled: !!sessionCreatedAt
  });

  useEffect(() => {
    if (!getPostBillingSessionSummary.data) return;

    if (getPostBillingSessionSummary.data.totalAmount > 0) {
      const { totalAmount, currency, customerLtvAvg } = getPostBillingSessionSummary.data;
      GoogleTagManagerService.sendSubscriptionPurchaseEvent(totalAmount, currency, customerLtvAvg);
    }

    navigate(redirectPath ?? ROUTE_LINKS.billing);
  }, [getPostBillingSessionSummary.data]);

  return <FullScreenLoader />;
}
